import { tap } from 'rxjs/operators';
import { HttpServiceBase } from '@utils';
import { httpService } from '@services/http';
import { logger } from '@services/logger';
import { FleetManagerClearDataDto } from './fleet-manager-clear-data.dto';

export class FleetManagerService extends HttpServiceBase {
	constructor() {
		super('fleet-manager');
	}

	deleteOrganiztionInfo(dto: Partial<FleetManagerClearDataDto>) {
		return httpService
			.delete<unknown>(this.getUrl(), `organization-info`, { params: dto, errorHandler: 'notification' })
			.pipe(tap((result) => logger.debug(`[${this.constructor.name}.${this.deleteOrganiztionInfo.name}]`, result)));
	}
}

export const fleetManagerService = new FleetManagerService();
